<div id="im-container" [ngClass]="type"><i class="pi pi-info-circle"></i> {{ message }}</div>